<template lang="pug">
  #confirm-first-order
    #tmp-container.mt-3.d-flex.mx-auto
      b-card.w-100.mt-1
        b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list") {{error_msg}}
        b-form(@submit.prevent="send()")
          confirm-neo-data(:regist_data="regist_data", :error_msg_list="error_msg_list").mx-auto
          contract-conditions.mx-3.mb-4(
            :show-neo="['light', 'standard', 'premium', 'chatplus'].includes(value.plan_name)",
            :show-chat="['premium', 'chatplus', 'chatluck'].includes(value.plan_name)",
            :show-clouza="value.clouza_check === true",
            :show-arena="value.web_arena === true",
            :show-cyber="value.cyber === true",
            :show-mailgates="value.mailgates === true")
          .order-action-area.mx-5.my-3.d-flex.justify-content-between.align-items-end
            b-button.order-action-button(pill, variant="outline-secondary", size="lg", @click="backPage()")
              .float-right.search_message.ml-1.font-weight-bold 戻る
              b-icon.float-left.next-icon(icon="arrow-left-circle")
            b-button.order-action-button.order-confirm-button(pill, type="submit", variant="outline-success", size="lg", :disabled="isLoading")
              span.search_message.mr-1.font-weight-bold 申し込みを確定する
              b-icon.next-icon(icon="arrow-right-circle")
      price-board(v-model="value")
</template>

<script>
import Api from '@/repositories/api'
import ConfirmNeoData from "@/components/firstOrder/ConfirmNeoData";
import ContractConditions from "@/components/ContractConditions";
import PriceBoard from "@/components/PriceBoard";
const FirstOrderRepository = Api.get('f201FirstOrder')

export default {
  name: "ConfirmFirstOrder",
  props: {
    value: { type: Object, required: true},
  },
  data() {
    return {
      error_msg_list: [],
      error_msg_list_2: {
        // プラン名
        plan_name: {
          error_msg: []
        },
        // プランユーザー数
        plan_user: {
          error_msg: []
        },
        // ビジネスチャットチャットラック ユーザー数
        chat: {
          error_msg: []
        },
        // 業務アプリ作成ツールAppSuite
        app_suite: {
          error_msg: []
        },
        // desknet's ウェブ会議
        web_conferencing: {
          error_msg: []
        },
        // オプションサービスチェックボックス
        option_service: {
          error_msg: []
        },
        // RoomMgrチェックボックス
        option_room_mgr: {
          error_msg: []
        },
        // 交通費・経費精算チェックボックス
        option_expense_settlement: {
          error_msg: []
        },
        // タイムカード＋CLOUZAチェックボックス
        clouza_check: {
          error_msg: []
        },
        // タイムカード＋CLOUZAユーザー数
        clouza_input: {
          error_msg: []
        },
        // タイムカード＋CLOUZA会社コード
        clouza_company_code: {
          error_msg: []
        },
        // タイムカード＋CLOUZA有休管理＋申請承認オプション
        paid_leave_option: {
          error_msg: []
        },
        // ディスク増設チェックボックス
        option_disk: {
          error_msg: []
        },
        // 増設容量
        option_disk_size: {
          error_msg: []
        },
        // Sync for smartphoneチェックボックス
        option_sync: {
          error_msg: []
        },
        // Sync for smartphoneユーザー数
        option_sync_input: {
          error_msg: []
        },
        // desknet'sドライブ ディスク増設チェックボックス
        option_dn_drive: {
          error_msg: []
        },
        // desknet'sドライブ 増設容量
        option_dn_drive_disk_size: {
          error_msg: []
        },
        // セキュリティオプションチェックボックス
        security_option: {
          error_msg: []
        },
        // BASIC認証チェックボックス
        basic_auth: {
          error_msg: []
        },
        // BASIC認証ユーザーID
        basic_auth_user: {
          error_msg: []
        },
        // BASIC認証パスワード
        basic_auth_password: {
          error_msg: []
        },
        // BASIC認証認証を除外するIPアドレス
        basic_auth_ip: {
          error_msg: []
        },
        // 接続元IPアドレス制限チェックボックス
        ip_restrictions: {
          error_msg: []
        },
        // 接続元IPアドレス制限接続を許可するIPアドレス
        ip_restrictions_ip: {
          error_msg: []
        },
        // セキュアブラウザチェックボックス
        secure_browser: {
          error_msg: []
        },
        // セキュアブラウザ端末認証
        secure_browser_terminal: {
          error_msg: []
        },
        // セキュアブラウザデバイス数
        secure_browser_device: {
          error_msg: []
        },
        // セキュアブラウザセキュアブラウザを適用しないIPアドレス
        secure_browser_ip: {
          error_msg: []
        },
        // クライアント認証チェックボックス
        client_auth: {
          error_msg: []
        },
        // クライアント認証デバイス数
        client_auth_input: {
          error_msg: []
        },
        // クライアント認証認証を除外するIPアドレス
        client_auth_ip: {
          error_msg: []
        },
        // メールサービスチェックボックス
        mail_service: {
          error_msg: []
        },
        // WebARENA
        web_arena: {
          error_msg: []
        },
        // WebARENA利用ドメイン名
        web_arena_domain: {
          error_msg: []
        },
        // WebARENAアカウント数
        web_arena_input: {
          error_msg: []
        },
        // CYBERMAILΣチェックボックス
        cyber: {
          error_msg: []
        },
        // CYBERMAILΣアカウント数
        cyber_input: {
          error_msg: []
        },
        // CYBERMAILΣメールボックス容量
        cyber_capacity: {
          error_msg: []
        },
        // CYBERMAILΣオプション
        cyber_option: {
          error_msg: []
        },
        // ご希望サブドメイン名
        sub_domain: {
          error_msg: [],
        },
        // サービス利用約款などチェックボックス
        provision_check: {
          error_msg: []
        },
        // 無料お試し版からのデータ移行
        migration: {
          error_msg: []
        },
        // 無料お試し版からのデータ移行試使用環境URL
        migration_url: {
          error_msg: []
        },
        // 無料お試し版からのデータ移行作業時刻
        migration_datetime: {
          error_msg: []
        },
        // ChatLuck オプションサービスチェックボックス
        chat_option_service: {
          error_msg: []
        },
        // ChatLuck ディスク増設チェックボックス
        chat_option_disk: {
          error_msg: []
        },
        // ChatLuck ディスク増設増設容量
        chat_option_disk_size: {
          error_msg: []
        },
        // ChatLuck セキュリティオプションチェックボックス
        chat_security_option: {
          error_msg: []
        },
        // ChatLuck BASIC認証チェックボックス
        chat_basic_auth: {
          error_msg: []
        },
        // ChatLuck BASIC認証ユーザーID
        chat_basic_auth_user: {
          error_msg: []
        },
        // ChatLuck BASIC認証パスワード
        chat_basic_auth_password: {
          error_msg: []
        },
        // ChatLuck BASIC認証認証を除外するIPアドレス
        chat_basic_auth_ip: {
          error_msg: []
        },
        // ChatLuck 接続元IPアドレス制限チェックボックス
        chat_ip_restrictions: {
          error_msg: []
        },
        // ChatLuck 接続元IPアドレス制限接続を許可するIPアドレス
        chat_ip_restrictions_ip: {
          error_msg: []
        },
        // ChatLuck ご希望サブドメイン名
        chat_sub_domain: {
          error_msg: []
        },
        // ChatLuck 無料お試し版からのデータ移行
        chat_migration: {
          error_msg: []
        },
        // ChatLuck 無料お試し版からのデータ移行試使用環境URL
        chat_migration_url: {
          error_msg: []
        },
        // ChatLuck 無料お試し版からのデータ移行作業時刻
        chat_migration_datetime: {
          error_msg: []
        },
        // ChatLuck ご利用開始希望日
        preferred_date: {
          error_msg: []
        },
        // お見積番号
        estimate: {
          error_msg: []
        },
        // 備考
        remarks: {
          error_msg: []
        },
        // 会社名・組織名
        company_name: {
          error_msg: []
        },
        // 外国法人に該当します
        foreign_company_flg: {
          error_msg: []
        },
        // 会社名・組織名(かな)
        company_kana: {
          error_msg: []
        },
        // LBC企業管理コード
        lbc_office_code: {
          error_msg: []
        },
        // 代表者名
        president_name: {
          error_msg: []
        },
        // 代表者名(かな)
        president_kana: {
          error_msg: []
        },
        // 部署名
        department: {
          error_msg: []
        },
        // 担当者名
        person_name: {
          error_msg: []
        },
        // 担当者名(かな)
        person_kana: {
          error_msg: []
        },
        // 郵便番号
        postal_code: {
          error_msg: []
        },
        // 住所
        address: {
          error_msg: []
        },
        // 都道府県
        prefecture: {
          error_msg: []
        },
        // 市区町村
        city: {
          error_msg: []
        },
        // 丁目番地
        address1: {
          error_msg: []
        },
        // 建物名以下
        address2: {
          error_msg: []
        },

        // 電話番号
        phone_number: {
          error_msg: []
        },
        // FAX番号
        fax_number: {
          error_msg: []
        },

        // ご契約種別
        contract_type: {
          error_msg: []
        },
        // お支払い方法
        payment_method: {
          error_msg: []
        },

        // 請求書送付先
        // 会社名
        bill_company_name: {
          error_msg: []
        },
        // 会社名・組織名(かな)
        bill_company_kana: {
          error_msg: []
        },
        // 部署名
        bill_department: {
          error_msg: []
        },
        // 担当者名
        bill_president_name: {
          error_msg: []
        },
        // 担当者名(かな)
        bill_president_kana: {
          error_msg: []
        },
        // 郵便番号
        bill_postal_code: {
          error_msg: []
        },
        // 住所
        bill_address: {
          error_msg: []
        },
        // 都道府県
        bill_prefecture: {
          error_msg: []
        },
        // 市区町村
        bill_city: {
          error_msg: []
        },
        // 丁目番地
        bill_address1: {
          error_msg: []
        },
        // 建物名以下
        bill_address2: {
          error_msg: []
        },
        // 電話番号
        bill_phone_number: {
          error_msg: []
        },
        // FAX番号
        bill_fax_number: {
          error_msg: []
        },
        // E-mail
        bill_e_mail: {
          error_msg: []
        },
        // E-mail(確認用)
        re_bill_e_mail: {
          error_msg: []
        },

        // パスワード
        password: {
          error_msg: []
        },
        // パスワード(確認用)
        re_password: {
          error_msg: []
        },
      },
      // 登録する入力内容
      regist_data: {},
    }
  },
  components: {
    ContractConditions,
    PriceBoard,
    ConfirmNeoData
  },
  created() {
    // propsのvalueの値をdataのregist_dataに変える
    // プラン
    this.initDataPlan()

    // NEO
    this.initDataNeo()

    // chatluck
    this.initDataChat()

    // 無料お試し版からのデータ移行がある場合
    if ((['light', 'standard', 'premium', 'chatplus'].indexOf(this.value.plan_name) !== -1 && Number(this.value.plan_user) > 0 && this.value.migration === true) ||
        (['premium', 'chatplus', 'chatluck'].indexOf(this.value.plan_name) !== -1 && Number(this.value.plan_user) > 0 && this.value.chat_migration === true)) {
      // 無料お試し版からのデータ移行作業日付
      this.regist_data.migration_date = this.value.migration_date || ''

      // 無料お試し版からのデータ移行作業時刻（から）
      this.regist_data.migration_time_from = this.value.migration_time_from || ''

      // 無料お試し版からのデータ移行作業時刻（まで）
      this.regist_data.migration_time_to = this.value.migration_time_to || ''
    }
    else {
      // 無料お試し版からのデータ移行が無い場合
      // ご利用開始希望日
      this.regist_data.preferred_date = this.value.preferred_date || ''
    }

    // お見積番号
    this.regist_data.estimate = this.value.estimate || ''

    // 備考
    this.regist_data.remarks = this.value.remarks || ''

    // サービス利用約款チェック
    this.regist_data.provision = this.value.provision_check || ''

    // ご契約者情報
    this.initDataCustoerInfo()

    // パスワード
    this.regist_data.password = this.value.password || ''
    this.regist_data.re_password = this.value.re_password || ''
  },
  methods: {
    // 表示するデータの初期化 プラン
    initDataPlan() {
      this.regist_data.plan = {}

      // プラン名（必須）
      this.regist_data.plan.type = this.value.plan_name || ''
      // プランユーザー数
      // プランを選択している場合
      if (['light', 'standard', 'premium', 'chatplus'].indexOf(this.value.plan_name) !== -1) {
        this.regist_data.plan.user = this.value.plan_user || 0
      }
    },
    // 表示するデータの初期化 NEO
    initDataNeo() {
      // NEO
      if (['light', 'standard', 'premium', 'chatplus'].indexOf(this.value.plan_name) !== -1) {
        this.regist_data.neo = {}

        // AppSUiteユーザー数
        if (this.value.app_suite_user) {
          this.regist_data.neo.app_suite_user = this.value.app_suite_user
        }

        // ウェブ会議室数
        if (this.value.web_conferencing) {
          this.regist_data.neo.web_conferencing = this.value.web_conferencing
        }

        // オプションサービス
        if (this.value.option_service === true) {
          let option = {}
          // RoomMgr
          if (this.value.option_room_mgr === true) {
            option.room_mgr = true
          }
          // 交通費・経費精算
          if (this.value.option_expense_settlement === true) {
            option.expense_settlement = true
          }
          // タイムカード＋CLOUZA
          if (this.value.clouza_check === true) {
            option.clouza = {
              user: this.value.clouza_input,
              clouza_company: this.value.clouza_company_code,
              paid_leave_option: this.value.paid_leave_option,
            }
          }
          // ディスク増設
          if (this.value.option_disk === true) {
            option.disk = {
              disk_size: this.value.option_disk_size
            }
          }
          // Sync for smartphone
          if (this.value.option_sync === true) {
            option.sync = {
              user: this.value.option_sync_input
            }
          }
          // desknet'sドライブ ディスク増設
          if (this.value.option_dn_drive === true) {
            option.dn_drive = {
              disk_size: this.value.option_dn_drive_disk_size
            }
          }

          this.regist_data.neo.option = option
        }

        // セキュリティオプション
        if (this.value.security_option === true) {
          let option = {}
          // BASIC認証
          if (this.value.basic_auth === true) {
            option.basic = {
              basic_id: this.value.basic_auth_user,
              basic_password: this.value.basic_auth_password,
              basic_except_ip: this.value.basic_auth_ip,
            }
          }
          // 接続元IPアドレス制限
          if (this.value.ip_restrictions === true) {
            option.connect_permit_ip = this.value.ip_restrictions_ip
          }
          // セキュアブラウザ
          if (this.value.secure_browser === true) {
            let itemQuantity = this.value.secure_browser_device

            // 端末認証なしの場合
            if (this.value.secure_browser_terminal === '01') {
              // secure_browser_deviceにプランユーザー数を格納する
              itemQuantity = this.value.plan_user
            }
            option.secure = {
              secure_browser_terminal: this.value.secure_browser_terminal,
              secure_browser_device: itemQuantity,
              secure_except_ip: this.value.secure_browser_ip,
            }
          }
          // クライアント認証
          if (this.value.client_auth === true) {
            option.client = {
              device: this.value.client_auth_input,
              cert_except_ip: this.value.client_auth_ip,
            }
          }

          this.regist_data.neo.security = option
        }

        // メールサービス
        if (this.value.mail_service === true) {
          let option = {}
          // WebARENA
          if (this.value.web_arena === true) {
            option.arena = {
              wa_domain: this.value.web_arena_domain,
              account: this.value.web_arena_input,
            }
          }
          // CYBERMAILΣ
          if (this.value.cyber === true) {
            option.cyber = {
              account: this.value.cyber_input,
              mailbox: this.value.cyber_capacity,
              options: [],
              keep: this.value.cyber_keep_period,
            }

            // オプション
            this.value.cyber_option.forEach((element, key) => {
              if (element === true) {
                option.cyber.options.push(('00' + key).slice(-2))
              }
            });
          }

          this.regist_data.neo.mail = option
        }

        // メールセキュリティサービス
        if (this.value.mail_security_service === true) {
          let option = {}

          // MAILGATES Σ
          if (this.value.mailgates === true) {
            option.mailgates = {
              mailgates_domain: this.value.mailgates_domain,
              account: this.value.mailgates_input,
              options: [],
            }

            // オプション
            this.value.mailgates_option.forEach((element, key) => {
              if (element === true) {
                option.mailgates.options.push(('00' + (key+1)).slice(-2))
              }
            });
          }

          this.regist_data.neo.mail_security = option
        }

        // ご希望サブドメイン名
        this.regist_data.neo.sub_domain = this.value.sub_domain || ''

        // 無料お試し版からのデータ移行
        if (this.value.migration === true) {
          this.regist_data.neo.migration_url = this.value.migration_url
        }
      }
    },
    // 表示するデータの初期化 chatluck
    initDataChat() {
      // chatluck
      if (['premium', 'chatplus', 'chatluck'].indexOf(this.value.plan_name) !== -1) {
        this.regist_data.chat = {}

        // chatluckユーザー数
        // ChatLuckを選択している場合
        if (this.value.plan_name === 'chatluck') {
          this.regist_data.chat.chat_user = this.value.plan_user || 0
        }

        // オプションサービス
        if (this.value.chat_option_service === true) {
          let option = {}
          // ディスク増設
          if (this.value.chat_option_disk === true) {
            option.disk = {
              disk_size: this.value.chat_option_disk_size
            }
          }

          this.regist_data.chat.option = option
        }

        // セキュリティオプション
        if (this.value.chat_security_option === true) {
          let option = {}
          // BASIC認証
          if (this.value.chat_basic_auth === true) {
            option.basic = {
              basic_id: this.value.chat_basic_auth_user,
              basic_password: this.value.chat_basic_auth_password,
              basic_except_ip: this.value.chat_basic_auth_ip,
            }
          }
          // 接続元IPアドレス制限
          if (this.value.chat_ip_restrictions === true) {
            option.connect_permit_ip = this.value.chat_ip_restrictions_ip
          }

          this.regist_data.chat.security = option
        }

        // ご希望サブドメイン名
        this.regist_data.chat.sub_domain = this.value.chat_sub_domain || ''

        // 無料お試し版からのデータ移行
        if (this.value.chat_migration === true) {
          this.regist_data.chat.migration_url = this.value.chat_migration_url
        }
      }
    },
    // 表示するデータの初期化 お客様情報
    initDataCustoerInfo() {
      // お客様情報
      this.regist_data.customer_info = {}
      this.regist_data.customer_info.firm_name = this.value.company_name || ''
      this.regist_data.customer_info.foreign_company_flg = this.value.foreign_company_flg || ''
      this.regist_data.customer_info.firm_kana = this.value.company_kana || ''
      this.regist_data.customer_info.lbc_office_code = this.value.lbc_office_code || ''
      this.regist_data.customer_info.president_name = this.value.president_name || ''
      this.regist_data.customer_info.president_kana = this.value.president_kana || ''
      this.regist_data.customer_info.department = this.value.department || ''
      this.regist_data.customer_info.person_name = this.value.person_name || ''
      this.regist_data.customer_info.person_kana = this.value.person_kana || ''
      this.regist_data.customer_info.zip_code = this.value.postal_code || ''
      this.regist_data.customer_info.prefecture = this.value.prefecture || ''
      this.regist_data.customer_info.city = this.value.city || ''
      this.regist_data.customer_info.address1 = this.value.address1 || ''
      this.regist_data.customer_info.address2 = this.value.address2 || ''
      this.regist_data.customer_info.tel = this.value.phone_number || ''
      this.regist_data.customer_info.fax = this.value.fax_number || ''
      this.regist_data.customer_info['e-mail'] = this.value.e_mail || ''

      // ご契約種別・お支払い方法
      this.regist_data.customer_info.token = this.value.token || ''
      this.regist_data.customer_info.contract_type = this.value.contract_type
      this.regist_data.customer_info.payment_method = this.value.payment_method

      // 請求書送付先
      // 請求者送付先チェックボックスがチェック済みで、請求書送付先の入力がない場合、契約者情報を登録用データに保存する
      if (this.value.send_invoice === true) {
        this.regist_data.customer_info.bill_firm_name = this.value.bill_company_name || this.value.company_name
        this.regist_data.customer_info.bill_firm_kana = this.value.bill_company_kana || this.value.company_kana
        this.regist_data.customer_info.bill_department = this.value.bill_department || this.value.department
        this.regist_data.customer_info.bill_person_name = this.value.bill_president_name || this.value.person_name
        this.regist_data.customer_info.bill_person_kana = this.value.bill_president_kana || this.value.person_kana
        this.regist_data.customer_info.bill_zip_code = this.value.bill_postal_code || this.value.postal_code
        this.regist_data.customer_info.bill_prefecture = this.value.bill_prefecture || this.value.prefecture
        this.regist_data.customer_info.bill_city = this.value.bill_city || this.value.city
        this.regist_data.customer_info.bill_address1 = this.value.bill_address1 || this.value.address1
        this.regist_data.customer_info.bill_address2 = this.value.bill_address2 || this.value.address2
        this.regist_data.customer_info.bill_tel = this.value.bill_phone_number || this.value.phone_number
        this.regist_data.customer_info.bill_fax = this.value.bill_fax_number || this.value.fax_number
        this.regist_data.customer_info.bill_e_mail = this.value.bill_e_mail || this.value.e_mail
        this.regist_data.customer_info.bill_re_e_mail = this.value.re_bill_e_mail || this.value.e_mail
      }
      // 請求書送付先のチェックボックスがチェックされていない場合、契約者情報を登録用データに保存する
      else {
        this.regist_data.customer_info.bill_firm_name = this.value.company_name
        this.regist_data.customer_info.bill_firm_kana = this.value.company_kana
        this.regist_data.customer_info.bill_department = this.value.department
        this.regist_data.customer_info.bill_person_name = this.value.person_name
        this.regist_data.customer_info.bill_person_kana = this.value.person_kana
        this.regist_data.customer_info.bill_zip_code = this.value.postal_code
        this.regist_data.customer_info.bill_prefecture = this.value.prefecture
        this.regist_data.customer_info.bill_city = this.value.city
        this.regist_data.customer_info.bill_address1 = this.value.address1
        this.regist_data.customer_info.bill_address2 = this.value.address2
        this.regist_data.customer_info.bill_tel = this.value.phone_number
        this.regist_data.customer_info.bill_fax = this.value.fax_number
        this.regist_data.customer_info.bill_e_mail = this.value.e_mail
        this.regist_data.customer_info.bill_re_e_mail = this.value.e_mail
      }
    },
    // 送信処理
    send() {
      // エラーメッセージを初期化する
      this.error_msg_list = []

      // 次へボタンをロックする
      this.isLoading = true;

      // パラメータを作成する
      let params = {}

      Object.keys(this.regist_data).forEach(key => {
        // プランの場合
        if (key === 'plan') {
          // ChatLuckの場合、パラメータにプランを追加しない
          if (this.regist_data[key].type === 'chatluck') {
            return
          }
        }
        // 値がセットされている場合はパラメータにセット
        if (this.regist_data[key]) {
          params[key] = this.regist_data[key]
        }
      })

      // お申し込みの登録処理を実施する
      FirstOrderRepository.add(params)
        .then(() => {
          // 登録完了画面へ遷移する
          this.$router.push({name: 'FinishFirstOrder'})
        })
        .catch((error) => {
          // 次へボタンをロックを解除する
          this.isLoading = false;

          // 共通のエラー処理
          this.apiError(error, '登録処理', 'FirstOrder')

          // 仮申込関連のエラーの場合
          if (error.response.status === 404) {
            this.$router.push({
              name: "RelatedTmpOrder",
              params: {
                // 仮申込のエラーメッセージは一つなので添字決め打ち
                error_msg: error.response.data.error_list[0].error_msg
              }
            })
          }

          // エラー発生時はエラーメッセージを表示する
          if (error.response.data && error.response.data.message) {
            // CakePHP Exception
            this.error_msg_list.push(error.response.data.message)
          } else if (error.response.data && error.response.data.error_list) {
            // バリデーションエラー
            // 項目確認のみで入力が無いので個別に表示しない
            for (let messages of error.response.data.error_list) {
              this.error_msg_list.push(messages.error_msg)
            }
          } else {
            // その他エラー
            this.error_msg_list.push(error)
          }

          // TODO:入力内容確認画面の各項目にエラーメッセージを表示する
          // エラー処理の作成
          if (error.response !== null && error.response !== undefined) {
            // エラー要素の取得
            const errList = error.response.data.error_list
            // 各要素のエラーメッセージを出力する
            errList.forEach((objErr) => {
              let target = objErr.target
              let errorMsg = objErr.error_msg
              this.responseErrorMessage(target, errorMsg)
            })
          }

          // TOP画面までスクロールをする
          this.pageTopScroll()
        })
    },
    // ページを戻る
    backPage() {
      // お客様情報入力画面へ遷移
      this.$router.push({
        name: "FirstOrderCustomerInfo",
        query: {
          token: this.value.token
        }
      })
    },
    responseErrorMessage(target, msg) {
      switch (target) {
        // プラン名
        case 'plan_name':
          this.error_msg_list_2.plan_name.error_msg.push(msg)
          break
        // プランユーザー数
        case 'plan_user':
          this.error_msg_list_2.plan_user.error_msg.push(msg)
          break
        // ビジネスチャットチャットラック ユーザー数
        case 'chat_user':
          this.error_msg_list_2.chat.error_msg.push(msg)
          break
        // 業務アプリ作成ツールAppSuite
        case 'app_suite_user':
          this.error_msg_list_2.app_suite.error_msg.push(msg)
          break
        // desknet's ウェブ会議
        case 'web_conferencing':
          this.error_msg_list_2.web_conferencing.error_msg.push(msg)
          break
        // オプションサービス チェックボックス
        case 'option_service':
          this.error_msg_list_2.option_service.error_msg.push(msg)
          break
        // RoomMgrチェックボックス
        case 'option_room_mgr':
          this.error_msg_list_2.option_room_mgr.error_msg.push(msg)
          break
        // 交通費・経費精算チェックボックス
        case 'option_expense_settlement':
          this.error_msg_list_2.option_expense_settlement.error_msg.push(msg)
          break
        // タイムカード＋CLOUZA
        case 'clouza_check':
          this.error_msg_list_2.clouza_check.error_msg.push(msg)
          break
        // タイムカード＋CLOUZAユーザー数
        case 'clouza_input':
          this.error_msg_list_2.clouza_input.error_msg.push(msg)
          break
        // タイムカード＋CLOUZA会社コード
        case 'clouza_company_code':
          this.error_msg_list_2.clouza_company_code.error_msg.push(msg)
          break
        // タイムカード＋CLOUZA有休管理＋申請承認オプション
        case 'paid_leave_option':
          this.error_msg_list_2.paid_leave_option.error_msg.push(msg)
          break
        // ディスク増設 チェックボックス
        case 'option_disk':
          // this.error_msg_list_2.option_disk.description = msg
          break
        // ディスク増設
        case 'option_disk_size':
          this.error_msg_list_2.option_disk_size.error_msg.push(msg)
          break
        // Sync for smartphones
        case 'option_sync':
          this.error_msg_list_2.option_sync.error_msg.push(msg)
          break
        // desknet'sドライブ ディスク増設
        case 'option_dn_drive_disk_size':
          this.error_msg_list_2.option_dn_drive_disk_size.error_msg.push(msg)
          break
        // セキュリティオプション チェックボックス
        case 'option_sync_input':
          this.error_msg_list_2.option_sync_input.error_msg.push(msg)
          break
        // BASIC認証チェックボックス
        case 'basic_auth':
          // this.error_msg_list_2.basic_auth.description = msg
          break
        // BASIC認証ユーザーID
        case 'basic_auth_user':
          this.error_msg_list_2.basic_auth_user.error_msg.push(msg)
          break
        // BASIC認証パスワード
        case 'basic_auth_password':
          this.error_msg_list_2.basic_auth_password.error_msg.push(msg)
          break
        // BASIC認証認証を除外するIPアドレス
        case 'basic_auth_ip':
          this.error_msg_list_2.basic_auth_ip.error_msg.push(msg)
          break
        // 接続を許可するIPアドレス チェックボックス
        case 'ip_restrictions':
          break
        // 接続を許可するIPアドレス
        case 'ip_restrictions_ip':
          this.error_msg_list_2.ip_restrictions_ip.error_msg.push(msg)
          break
        // セキュアブラウザチェックボックス
        case 'secure_browser':
          this.error_msg_list_2.secure_browser.error_msg.push(msg)
          break
        // セキュアブラウザ端末認証
        case 'secure_browser_terminal':
          this.error_msg_list_2.secure_browser_terminal.error_msg.push(msg)
          break
        // セキュアブラウザデバイス数
        case 'secure_browser_device':
          this.error_msg_list_2.secure_browser_device.error_msg.push(msg)
          break
        // セキュアブラウザセキュアブラウザを適用しないIPアドレス
        case 'secure_browser_ip':
          this.error_msg_list_2.secure_browser_ip.error_msg.push(msg)
          break
        // クライアント認証チェックボックス
        case 'client_auth':
          this.error_msg_list_2.client_auth.error_msg.push(msg)
          break
        // クライアント認証デバイス数
        case 'client_auth_input':
          this.error_msg_list_2.client_auth_input.error_msg.push(msg)
          break
        // クライアント認証認証を除外するIPアドレス
        case 'client_auth_ip':
          this.error_msg_list_2.client_auth_ip.error_msg.push(msg)
          break
        // メールサービス チェックボックス
        case 'mail_service':
          break
        // WebARENA
        case 'web_arena':
          this.error_msg_list_2.web_arena.error_msg.push(msg)
          break
        // WebARENA利用ドメイン名
        case 'web_arena_domain':
          this.error_msg_list_2.web_arena_domain.error_msg.push(msg)
          break
        // WebARENAアカウント数
        case 'web_arena_input':
          this.error_msg_list_2.web_arena_input.error_msg.push(msg)
          break
        // CYBERMAILΣチェックボックス
        case 'cyber':
          this.error_msg_list_2.cyber.error_msg.push(msg)
          break
        // CYBERMAILΣアカウント数
        case 'cyber_input':
          this.error_msg_list_2.cyber_input.error_msg.push(msg)
          break
        // CYBERMAILΣメールボックス容量
        case 'cyber_capacity':
          this.error_msg_list_2.cyber_capacity.error_msg.push(msg)
          break
        // CYBERMAILΣオプション
        case 'cyber_option':
          this.error_msg_list_2.cyber_option.error_msg.push(msg)
          break
        // CYBERMAILΣメールアーカイブ＆監査保存期間
        case 'cyber_keep_period':
          this.error_msg_list_2.cyber_option.options[2].error_msg.push(msg)
          break
        // ご希望サブドメイン名
        case 'subdomain_name':
          this.error_msg_list_2.sub_domain.error_msg.push(msg)
          break
        // 無料お試し版からのデータ移行チェックボックス
        case 'migration':
          this.error_msg_list_2.migration.error_msg.push(msg)
          break
        // 無料お試し版からのデータ移行試使用環境URL
        case 'migration_url':
          this.error_msg_list_2.migration_url.error_msg.push(msg)
          break
        // ChatLuck オプションサービスチェックボックス
        case 'chat_option_service':
          break
        // ChatLuck ディスク増設チェックボックス
        case 'chat_option_disk':
          this.error_msg_list_2.chat_option_disk.error_msg.push(msg)
          break
        // ChatLuck ディスク増設増設容量
        case 'chat_option_disk_size':
          this.error_msg_list_2.chat_option_disk_size.error_msg.push(msg)
          break
        // ChatLuck セキュリティオプションチェックボックス
        case 'chat_security_option':
          break
        // ChatLuck BASIC認証チェックボックス
        case 'chat_basic_auth':
          this.error_msg_list_2.chat_basic_auth.error_msg.push(msg)
          break
        // ChatLuck BASIC認証ユーザーID
        case 'chat_basic_auth_user':
          this.error_msg_list_2.chat_basic_auth_user.error_msg.push(msg)
          break
        // ChatLuck BASIC認証パスワード
        case 'chat_basic_auth_password':
          this.error_msg_list_2.chat_basic_auth_password.error_msg.push(msg)
          break
        // ChatLuck BASIC認証認証を除外するIPアドレス
        case 'chat_basic_auth_ip':
          this.error_msg_list_2.chat_basic_auth_ip.error_msg.push(msg)
          break
        // ChatLuck 接続元IPアドレス制限チェックボックス
        case 'chat_ip_restrictions':
          this.error_msg_list_2.chat_ip_restrictions.error_msg.push(msg)
          break
        // ChatLuck 接続元IPアドレス制限接続を許可するIPアドレス
        case 'chat_ip_restrictions_ip':
          this.error_msg_list_2.chat_ip_restrictions_ip.error_msg.push(msg)
          break
        // ChatLuck ご希望サブドメイン名
        case 'chat_sub_domain':
          this.error_msg_list_2.chat_sub_domain.error_msg.push(msg)
          break
        // ChatLuck 無料お試し版からのデータ移行
        case 'chat_migration':
          this.error_msg_list_2.chat_migration.error_msg.push(msg)
          break
        // ChatLuck 無料お試し版からのデータ移行試使用環境URL
        case 'chat_migration_url':
          this.error_msg_list_2.chat_migration_url.error_msg.push(msg)
          break
        // ChatLuck ご利用開始希望日
        case 'preferred_date':
          this.error_msg_list_2.preferred_date.error_msg.push(msg)
          break
        // お見積番号
        case 'estimate':
          this.error_msg_list_2.estimate.error_msg.push(msg)
          break
        // 備考
        case 'remarks':
          this.error_msg_list_2.remarks.error_msg.push(msg)
          break
        // 無料お試し版からのデータ移行作業日付
        case 'migration_date':
          this.error_msg_list_2.migration_datetime.error_msg.push(msg)
          break
        // 無料お試し版からのデータ移行作業時刻（から）
        case 'migration_time_from':
          this.error_msg_list_2.migration_datetime.error_msg.push(msg)
          break
        // 無料お試し版からのデータ移行作業時刻（まで）
        case 'migration_time_to':
          this.error_msg_list_2.migration_datetime.error_msg.push(msg)
          break
        // サービス利用約款などチェックボックス
        case 'provision_check':
          this.error_msg_list_2.provision_check.error_msg.push(msg)
          break
        // 会社名・組織名
        case "company_name":
          this.error_msg_list_2.company_name.error_msg.push(msg)
          break
        // 外国法人に該当します
        case "foreign_company_flg":
          this.error_msg_list_2.foreign_company_flg.error_msg.push(msg)
          break
        // 会社名・組織名(かな)
        case "company_kana":
          this.error_msg_list_2.company_kana.error_msg.push(msg)
          break
        // LBC企業管理コード
        case "lbc_office_code":
          this.error_msg_list_2.lbc_office_code.error_msg.push(msg)
          break
        // 代表者名
        case "president_name":
          this.error_msg_list_2.president_name.error_msg.push(msg)
          break
        // 代表者名(かな)
        case "president_kana":
          this.error_msg_list_2.president_kana.error_msg.push(msg)
          break
        // 部署名
        case "department":
          this.error_msg_list_2.department.error_msg.push(msg)
          break
        // 担当者名
        case "person_name":
          this.error_msg_list_2.person_name.error_msg.push(msg)
          break
        // 担当者名(かな)
        case "person_kana":
          this.error_msg_list_2.person_kana.error_msg.push(msg)
          break
        // 郵便番号
        case "postal_code":
          this.error_msg_list_2.postal_code.error_msg.push(msg)
          break
        // 都道府県
        case "prefecture":
          this.error_msg_list_2.prefecture.error_msg.push(msg)
          break
        // 市区町村
        case "city":
          this.error_msg_list_2.city.error_msg.push(msg)
          break
        // 丁目番地
        case "address1":
          this.error_msg_list_2.address1.error_msg.push(msg)
          break
        // 建物名以下
        case "address2":
          this.error_msg_list_2.address2.error_msg.push(msg)
          break
        // 電話番号
        case "phone_number":
          this.error_msg_list_2.phone_number.error_msg.push(msg)
          break
        // FAX番号
        case "fax_number":
          this.error_msg_list_2.fax_number.error_msg.push(msg)
          break
        // ご契約種別
        case "contract_type":
          this.error_msg_list_2.contract_type.error_msg.push(msg)
          break
        // お支払い方法
        case "payment_method":
          this.error_msg_list_2.payment_method.error_msg.push(msg)
          break
        // 請求書送付先
        // 会社名・組織名
        case "bill_company_name":
          this.error_msg_list_2.bill_company_name.error_msg.push(msg)
          break
        // 会社名・組織名（かな）
        case "bill_company_kana":
          this.error_msg_list_2.bill_company_kana.error_msg.push(msg)
          break
        // 部署名
        case "bill_department":
          this.error_msg_list_2.bill_department.error_msg.push(msg)
          break
        // 担当者名
        case "bill_president_name":
          this.error_msg_list_2.bill_president_name.error_msg.push(msg)
          break
        // 担当者(かな)
        case "bill_president_kana":
          this.error_msg_list_2.bill_president_kana.error_msg.push(msg)
          break
        // 郵便番号
        case "bill_postal_code":
          this.error_msg_list_2.bill_postal_code.error_msg.push(msg)
          break
        // 都道府県
        case "bill_prefecture":
          this.error_msg_list_2.bill_prefecture.error_msg.push(msg)
          break
        // 市区町村
        case "bill_city":
          this.error_msg_list_2.bill_city.error_msg.push(msg)
          break
        // 丁目番地
        case "bill_address1":
          this.error_msg_list_2.bill_address1.error_msg.push(msg)
          break
        // 建物名以下
        case "bill_address2":
          this.error_msg_list_2.bill_address2.error_msg.push(msg)
          break
        // 電話番号
        case "bill_phone_number":
          this.error_msg_list_2.bill_phone_number.error_msg.push(msg)
          break
        // FAX番号
        case "bill_fax_number":
          this.error_msg_list_2.bill_fax_number.error_msg.push(msg)
          break
        // E-mail
        case "bill_e_mail":
          this.error_msg_list_2.bill_e_mail.error_msg.push(msg)
          break
        // E-mail(確認用)
        case "re_bill_e_mail":
          this.error_msg_list_2.re_bill_e_mail.error_msg.push(msg)
          break
        // パスワード
        case "password":
          this.error_msg_list_2.password.error_msg.push(msg)
          break
        // パスワード(確認用)
        case "re_password":
          this.error_msg_list_2.re_password.error_msg.push(msg)
          break
        default:
          break
      }
    },
    resetErrorMsg() {
      // 全てのエラーメッセージ要素を空にする
      this.error_msg_list_2.plan_name = []
      this.error_msg_list_2.plan_user = []
      this.error_msg_list_2.chat.error_msg = []
      this.error_msg_list_2.app_suite.error_msg = []
      this.error_msg_list_2.web_conferencing.error_msg = []
      this.error_msg_list_2.option_service.error_msg = []
      this.error_msg_list_2.option_room_mgr.error_msg = []
      this.error_msg_list_2.option_expense_settlement.error_msg = []
      this.error_msg_list_2.clouza_check.error_msg = []
      this.error_msg_list_2.clouza_input.error_msg = []
      this.error_msg_list_2.clouza_company_code.error_msg = []
      this.error_msg_list_2.paid_leave_option.error_msg = []
      this.error_msg_list_2.option_disk_size.error_msg = []
      this.error_msg_list_2.option_sync.error_msg = []
      this.error_msg_list_2.option_sync_input.error_msg = []
      this.error_msg_list_2.option_dn_drive_disk_size.error_msg = []
      this.error_msg_list_2.basic_auth_user.error_msg = []
      this.error_msg_list_2.basic_auth_password.error_msg = []
      this.error_msg_list_2.basic_auth_ip.error_msg = []
      this.error_msg_list_2.ip_restrictions_ip.error_msg = []
      this.error_msg_list_2.secure_browser.error_msg = []
      this.error_msg_list_2.secure_browser_terminal.error_msg = []
      this.error_msg_list_2.secure_browser_device.error_msg = []
      this.error_msg_list_2.secure_browser_ip.error_msg = []
      this.error_msg_list_2.client_auth.error_msg = []
      this.error_msg_list_2.client_auth_input.error_msg = []
      this.error_msg_list_2.client_auth_ip.error_msg = []
      this.error_msg_list_2.web_arena.error_msg = []
      this.error_msg_list_2.web_arena_domain.error_msg = []
      this.error_msg_list_2.web_arena_input.error_msg = []
      this.error_msg_list_2.cyber.error_msg = []
      this.error_msg_list_2.cyber_input.error_msg = []
      this.error_msg_list_2.cyber_capacity.error_msg = []
      this.error_msg_list_2.cyber_option.error_msg = []
      this.error_msg_list_2.cyber_option.options[2].error_msg = []
      this.error_msg_list_2.sub_domain.error_msg = []
      this.error_msg_list_2.migration.error_msg = []
      this.error_msg_list_2.migration_url.error_msg = []
      this.error_msg_list_2.chat_option_disk.error_msg = []
      this.error_msg_list_2.chat_option_disk_size.error_msg = []
      this.error_msg_list_2.chat_basic_auth.error_msg = []
      this.error_msg_list_2.chat_basic_auth_user.error_msg = []
      this.error_msg_list_2.chat_basic_auth_password.error_msg = []
      this.error_msg_list_2.chat_basic_auth_ip.error_msg = []
      this.error_msg_list_2.chat_ip_restrictions.error_msg = []
      this.error_msg_list_2.chat_ip_restrictions_ip.error_msg = []
      this.error_msg_list_2.chat_sub_domain.error_msg = []
      this.error_msg_list_2.chat_migration.error_msg = []
      this.error_msg_list_2.chat_migration_url.error_msg = []
      this.error_msg_list_2.preferred_date.error_msg = []
      this.error_msg_list_2.estimate.error_msg = []
      this.error_msg_list_2.remarks.error_msg = []
      this.error_msg_list_2.migration_datetime.error_msg = []
      this.error_msg_list_2.provision_check.error_msg = []
      this.error_msg_list_2.company_name.error_msg = []
      this.error_msg_list_2.foreign_company_flg.error_msg = []
      this.error_msg_list_2.company_kana.error_msg = []
      this.error_msg_list_2.president_name.error_msg = []
      this.error_msg_list_2.president_kana.error_msg = []
      this.error_msg_list_2.department.error_msg = []
      this.error_msg_list_2.person_name.error_msg = []
      this.error_msg_list_2.person_kana.error_msg = []
      this.error_msg_list_2.postal_code.error_msg = []
      this.error_msg_list_2.address.error_msg = []
      this.error_msg_list_2.prefecture.error_msg = []
      this.error_msg_list_2.city.error_msg = []
      this.error_msg_list_2.address1.error_msg = []
      this.error_msg_list_2.address2.error_msg = []
      this.error_msg_list_2.phone_number.error_msg = []
      this.error_msg_list_2.fax_number.error_msg = []
      this.error_msg_list_2.contract_type.error_msg = []
      this.error_msg_list_2.payment_method.error_msg = []
      this.error_msg_list_2.bill_company_name.error_msg = []
      this.error_msg_list_2.bill_company_kana.error_msg = []
      this.error_msg_list_2.bill_department.error_msg = []
      this.error_msg_list_2.bill_president_name.error_msg = []
      this.error_msg_list_2.bill_president_kana.error_msg = []
      this.error_msg_list_2.bill_postal_code.error_msg = []
      this.error_msg_list_2.bill_address.error_msg = []
      this.error_msg_list_2.bill_prefecture.error_msg = []
      this.error_msg_list_2.bill_city.error_msg = []
      this.error_msg_list_2.bill_address1.error_msg = []
      this.error_msg_list_2.bill_address2.error_msg = []
      this.error_msg_list_2.bill_phone_number.error_msg = []
      this.error_msg_list_2.bill_fax_number.error_msg = []
      this.error_msg_list_2.bill_e_mail.error_msg = []
      this.error_msg_list_2.re_bill_e_mail.error_msg = []
      this.error_msg_list_2.password.error_msg = []
      this.error_msg_list_2.re_password.error_msg = []
    }
  }
}
</script>

<style scoped>
.next-icon {
  margin-top: 2px;
}
.order-action-button {
  height: 48px;
}
</style>
